import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function GameProvider({ children }) {
  const [user, setUser] = useState(null); // null checking, false signed out
  const [game, setGame] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/game/state");
      setGame(data);
      setUser(data.user);
      return data;
    } catch (e) {
      if (e?.response?.status === 401) { setUser(false); setGame(null); }
      return null;
    }
  }, []);

  useEffect(() => {
    // Skip while returning from Google sign-in; AuthCallback creates the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false); setGame(null);
  };

  return <Ctx.Provider value={{ user, game, refresh, logout, setUser }}>{children}</Ctx.Provider>;
}

export const useGame = () => useContext(Ctx);
